// extracted by mini-css-extract-plugin
export default {"searchBox":"index_searchBox_x0KFy","notice":"index_notice_0CLuy","noticeList":"index_noticeList_vhHXq"};